import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';


const ConviteSucesso = (props) => {

  const { open, onClose } = props;

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Convite Enviado com Sucesso</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Os usuários convidados que possuem emails
          cadastrados terão, automaticamente acesso direto à plataforma.
          </DialogContentText>
      </DialogContent>
    </Dialog>
  );

}

export default ConviteSucesso;
